export const ACTION_PERMISSION_DENIED_MESSAGE = "You do not have permission to perform this action. Please contact your administrator.";

const ADMIN_ROLES = ["admin", "superadmin", "super_admin", "alladmins", "all_admins"];
const VALID_ACTIONS = ["view", "add", "create", "edit", "delete"];

export const normalizePermissionRole = (role) =>
  (role || "").toString().trim().toLowerCase();

export const normalizePermissionAction = (action) =>
  (action || "").toString().trim().toLowerCase();

const getRolePermissions = (permissionsRoot, role) => {
  const rawRole = (role || "").toString().trim();
  const normalizedRole = normalizePermissionRole(role);
  return permissionsRoot?.[rawRole] || permissionsRoot?.[normalizedRole];
};

export const getAccessPermissionValue = ({ role, moduleKey, action, accessPermissions }) => {
  if (!role || !moduleKey || !action || !accessPermissions) {
    return undefined;
  }

  const actionKey = normalizePermissionAction(action);
  if (!VALID_ACTIONS.includes(actionKey)) {
    return undefined;
  }

  const permissionsRoot = accessPermissions.permissions || accessPermissions;
  const rolePermissions = getRolePermissions(permissionsRoot, role);
  const modulePermissions = rolePermissions?.[moduleKey];
  const permission = modulePermissions?.[action] ?? modulePermissions?.[actionKey];

  return typeof permission === "boolean" ? permission : undefined;
};

export const canDoAction = ({ role, moduleKey, action, accessPermissions, fallback = true }) => {
  try {
    if (ADMIN_ROLES.includes(normalizePermissionRole(role))) {
      return true;
    }

    const permission = getAccessPermissionValue({ role, moduleKey, action, accessPermissions });
    return typeof permission === "boolean" ? permission : fallback;
  } catch (error) {
    return fallback;
  }
};

export const getModuleActionPermissions = ({ role, moduleKey, accessPermissions, fallback = true }) => ({
  canAdd: canDoAction({ role, moduleKey, action: "add", accessPermissions, fallback }),
  canCreate: canDoAction({ role, moduleKey, action: "create", accessPermissions, fallback }),
  canEdit: canDoAction({ role, moduleKey, action: "edit", accessPermissions, fallback }),
  canDelete: canDoAction({ role, moduleKey, action: "delete", accessPermissions, fallback })
});

export const showActionPermissionDenied = () => {
  if (typeof window !== "undefined" && typeof window.alert === "function") {
    window.alert(ACTION_PERMISSION_DENIED_MESSAGE);
  }
};

export const requireActionPermission = (options) => {
  const allowed = canDoAction(options);
  if (!allowed) {
    showActionPermissionDenied();
  }
  return allowed;
};

export const filterEditableActions = ({ editable = {}, permissions = {} }) => {
  const allowed = {};

  if (permissions.canAdd && editable.onRowAdd) {
    allowed.onRowAdd = editable.onRowAdd;
  }
  if (permissions.canEdit && editable.onRowUpdate) {
    allowed.onRowUpdate = editable.onRowUpdate;
  }
  if (permissions.canDelete && editable.onRowDelete) {
    allowed.onRowDelete = editable.onRowDelete;
  }

  return Object.keys(allowed).length ? allowed : null;
};
